import { IDeal } from '@/dealboard/types/deal';

export class DealboardHelper {
  static getPaginatedDeals(deals: IDeal[], pagination: { currentPage: number; pageSize: number }) {
    if (!pagination) {
      return deals;
    }
    if (!deals) {
      return [];
    }
    const startIndex: number = pagination.currentPage * pagination.pageSize;
    const endIndex: number = startIndex + pagination.pageSize;
    return deals.slice(startIndex, endIndex);
  }

  static getAcceleratorScoreExplanations(language: string, scoreExplanations: string): string[] {
    const reasons = this.getReasons(language);
    const explanations = scoreExplanations.split(',');
    const tooltip: string[] = [];
    for (const e of explanations) {
      const explanation = e.split(':');
      if (explanation.length === 2) {
        tooltip.push(
          reasons[explanation[1]]?.[+explanation[0] < 0 ? 1 : 0]
            ? reasons[explanation[1]][+explanation[0] < 0 ? 1 : 0]
            : explanation[1]
        );
      }
    }
    return tooltip;
  }

  static getReasons(language: string) {
    if (language === 'sv') {
      return {
        opened_email: [
          'Mottagaren har öppnat epost',
          'Prova att skicka SMS, chatt eller ett video meddelande',
        ],
        opened_attachment: [
          'Bilagor till dokumentet har öppnats',
          'En påminnelse om dokumentets bilagor rekommenderas',
        ],
        opened_mobile: ['Även öppnat på mobil enhet', 'Verkar inte ha öppnat på mobil enhet'],
        has_video: [
          'Video verkar ha gett bra effekt',
          'Försök att spela in en kort och tydlig video',
        ],
        has_verified: [
          'Har tagit nästa steg mot ett avslut',
          'Kontakta signerare eller godkännare',
        ],
        has_approved: ['Redo för signering', 'Identifiera och prata med beslutsfattare'],
        send_day: ['Bra tajming här', 'Kanske prova att skicka vid en annan tidpunkt'],
        reminder_count: [
          'Påminnelserna verkar ha hjälpt',
          'Prova att påminna via chatt eller video meddelande',
        ],
        view_count: [
          'Har visat ett starkt intresse',
          'Försök engagera mottagare med ytterligare kommunikation',
        ],
        recipient_comment: [
          'Bra engagemang - dags för avslut?',
          'Använd mobilappen för att snabbare svara på meddelanden',
        ],
        sender_comment: [
          'Smarta kommentarer driver ökat engagemang',
          'Prova att lägga till automatiska kommentarer',
        ],
        has_printed: [
          'Har kanske delats med andra för diskussion',
          'Följ upp med ett samtal efter en utskrift',
        ],
        has_downloaded: [
          'Sparar eller delar antagligen med andra',
          'Följ upp med ett samtal efter nedladdning',
        ],
        has_forwarded: [
          'Se om det har tillkommit andra beslutsfattare',
          'Identifiera rätt beslutsfattare tidigt',
        ],
        recipient_count: [
          'Fråga tidigt vilka mottagare som är viktiga för ett beslut',
          'Många beslutsfattare och mottagare kan komplicera affären. Följ upp med alla.',
        ],
        view_time: [
          'Har lagt god tid på att förstå dokumentet',
          'Har de fastnat på någon specifik sida kanske?',
        ],
        has_clevel: [
          'Du verkar ha hittat rätt beslutsfattare',
          'Lägg god tid på att identifiera rätt beslutsfattare',
        ],
        time_to_open: [
          'Aktiv och bör följas upp inom kort tid',
          'Prova att skicka med andra kanaler som SMS, chat och video.',
        ],
        first_to_last_sending: [
          'Bra och korta ledtider mellan utskicken',
          'Försök hålla en kortare process',
        ],
      };
    }
    return {
      opened_email: [
        'Recipient has seen the email message',
        'Send via SMS, a chat within the document, or video reminder',
      ],
      opened_attachment: [
        'Additional collateral was helpful',
        'Try reminding about attachments via chat',
      ],
      opened_mobile: [
        'Still caught attention whilst on the move',
        'Not enough time to review whilst on the move',
      ],
      has_video: ['Video is precise and to the point', 'Try to record short and concise videos'],
      has_verified: ['Progressing through the workflow', 'Contact approver or signer to discuss'],
      has_approved: ['Approved and ready to get signed', 'Discuss with decision maker'],
      send_day: ['Sending day is good', 'Try different time for your sending'],
      reminder_count: [
        'Shows high priority and interest',
        'Try reminding via text, chat or video message',
      ],
      view_count: [
        'Important enough to open multiple times',
        'Try to engage with chat or video message',
      ],
      recipient_comment: [
        'Good communication with recipient',
        'Download the mobile app to answer chat messages faster',
      ],
      sender_comment: [
        'Comments are great way to engage with recipient',
        'Try the mobile app to send comments',
      ],
      has_printed: [
        'Might be sharing it in person with someone',
        'After printing it could be a good time to reach out',
      ],
      has_downloaded: [
        'Looking to store or share the information',
        'Did you follow up on why the recipient downloaded?',
      ],
      has_forwarded: [
        'You might have a new decision maker',
        'Make sure you identify the right decision maker',
      ],
      recipient_count: [
        'Ask if anyone else needs to be involved in the decision making',
        'Complex deal with a lot of decision makers. Be patient, but persistent.',
      ],
      view_time: [
        'Understands document content',
        'Are they stuck at a specific part of the document?',
      ],
      has_clevel: [
        'You seem to have identified the right person(s)',
        'Identify the decision maker in the organization',
      ],
      time_to_open: [
        'Shows high priority and interest',
        'Try sending via other forms, such as SMS',
      ],
      first_to_last_sending: [
        'Information was easy to understand ',
        'Try resurrecting with chat or video reminder',
      ],
    };
  }
}
